import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Container, Row, Col, Card, CardBody, Button, Spinner,
  FormGroup, Label, Input, FormFeedback,
} from 'reactstrap'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import qs from 'qs'
import Select from '../../../components/Template/Input/Select'
import MaskedInput from '../../../components/Template/Input/MaskedInput'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import oikosApi from '../../../services/oikos'
import { notifyError, notifySuccess } from '../../../utils/notify'

class Profile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      getPersonIsLoading: false,
      person: {},
      editPersonIsLoading: false,

      getSexoTypesIsLoading: false,
      sexoTypes: [],

      getEstadoCivilTypesIsLoading: false,
      estadoCivilTypes: [],

      getTipoSanguineoTypesIsLoading: false,
      tipoSanguineoTypes: [],

      getUfTypesIsLoading: false,
      ufTypes: [],

      getMunTypesIsLoading: false,
      munTypes: [],

      getIdiomaTypesIsLoading: false,
      idiomaTypes: [],
    }
  }

  componentDidMount() {
    this.getPerson()
    this.getSexoTypes()
    this.getEstadoCivilTypes()
    this.getTipoSanguineoTypes()
    this.getUfTypes()
    this.getMunTypes()
    this.getIdiomaTypes()
  }

  getPerson = async () => {
    this.setState({ getPersonIsLoading: true, person: {} })

    try {
      const { id } = this.props.auth.user

      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pf',
        data: {
          pf_graphId: id,
        },
      })}`)
      console.tron.log('res getPerson', res)

      this.setState({ getPersonIsLoading: false, person: res.data[0] })
    } catch (e) {
      console.tron.log('Não foi possível carregar os dados do perfil.', e)
      notifyError('Não foi possível carregar os dados do perfil.')
      this.setState({ getPersonIsLoading: false, person: {} })
    }
  }

  getSexoTypes = async () => {
    this.setState({ getSexoTypesIsLoading: true, sexoTypes: null })

    let sexoTypes = null

    try {
      const res = await oikosApi.get('/', {
        action: 'get',
        table: 'sexo',
      })
      console.tron.log('res getSexoTypes', res)

      sexoTypes = res.data.map(i => ({
        value: i.sexo_id,
        label: i.sexo_nome,
      }))
    } catch (e) {
      console.tron.log(e)
      notifyError(e)
    }

    this.setState({ getSexoTypesIsLoading: false, sexoTypes })
  }

  getEstadoCivilTypes = async () => {
    this.setState({ getEstadoCivilTypesIsLoading: true, estadoCivilTypes: null })

    let estadoCivilTypes = null

    try {
      const res = await oikosApi.get('/', {
        action: 'get',
        table: 'estCiv',
      })
      console.tron.log('res getEstadoCivilTypes', res)

      estadoCivilTypes = res.data.map(i => ({
        value: i.estCiv_id,
        label: i.estCiv_situacao,
      }))
    } catch (e) {
      console.tron.log(e)
      notifyError(e)
    }

    this.setState({ getEstadoCivilTypesIsLoading: false, estadoCivilTypes })
  }

  getTipoSanguineoTypes = async () => {
    this.setState({ getTipoSanguineoTypesIsLoading: true, tipoSanguineoTypes: null })

    let tipoSanguineoTypes = null

    try {
      const res = await oikosApi.get('/', {
        action: 'get',
        table: 'tpSangue',
      })
      console.tron.log('res getTipoSanguineoTypes', res)

      tipoSanguineoTypes = res.data.map(i => ({
        value: i.tpSangue_id,
        label: i.tpSangue_tipo,
      }))
    } catch (e) {
      console.tron.log(e)
      notifyError(e)
    }

    this.setState({ getTipoSanguineoTypesIsLoading: false, tipoSanguineoTypes })
  }

  getUfTypes = async () => {
    this.setState({ getUfTypesIsLoading: true, ufTypes: null })

    let ufTypes = null

    try {
      const res = await oikosApi.get('/', {
        action: 'get',
        table: 'uf',
      })
      console.tron.log('res getUfTypes', res)

      ufTypes = res.data.map(i => ({
        value: i.uf_id,
        label: i.uf_nome,
      }))
    } catch (e) {
      console.tron.log(e)
      notifyError(e)
    }

    this.setState({ getUfTypesIsLoading: false, ufTypes })
  }

  getMunTypes = async () => {
    this.setState({ getMunTypesIsLoading: true, munTypes: null })

    let munTypes = null

    try {
      const res = await oikosApi.get('/', {
        action: 'get',
        table: 'mun',
      })
      console.tron.log('res getMunTypes', res)

      munTypes = res.data.map(i => ({
        value: i.mun_id,
        label: i.mun_nome,
      }))
    } catch (e) {
      console.tron.log(e)
      notifyError(e)
    }

    this.setState({ getMunTypesIsLoading: false, munTypes })
  }

  getIdiomaTypes = async () => {
    this.setState({ getIdiomaTypesIsLoading: true, idiomaTypes: null })

    let idiomaTypes = null

    try {
      const res = await oikosApi.get('/', {
        action: 'get',
        table: 'idioma',
      })
      console.tron.log('res getIdiomaTypes', res)

      idiomaTypes = res.data.map(i => ({
        value: i.idioma_id,
        label: i.idioma_nome,
      }))
    } catch (e) {
      console.tron.log(e)
      notifyError(e)
    }

    this.setState({ getIdiomaTypesIsLoading: false, idiomaTypes })
  }

  handleEditPersonSubmit = async () => {
    try {
      this.setState({ editPersonIsLoading: true })

      const { person } = this.state
      console.tron.log('person handleEditPersonSubmit', person)

      const body = {
        action: 'update',
        table: 'pf',
        data: {
          pf_id: person.pf_id,
          pf_nome: person.pf_nome || undefined,
          pf_sobrenome: person.pf_sobrenome || undefined,
          pf_nomeExibicao: person.pf_nomeExibicao || undefined,
          sexo_id: person.sexo_id || undefined,
          pf_rg: person.pf_rg || undefined,
          pf_cpf: person.pf_cpf || undefined,
          estCiv_id: person.estCiv_id || undefined,
          pf_dtNasc: person.pf_dtNasc || undefined,
          tpSangue_id: person.tpSangue_id || undefined,
          pf_tpCnh: person.pf_tpCnh || undefined,
          pf_arrais: person.pf_arrais || undefined,
          pf_segSaude: person.pf_segSaude || undefined,
          pf_ctps: person.pf_ctps || undefined,
          pf_emailProf: person.pf_emailProf || undefined,
          pf_celProf: person.pf_celProf || undefined,
          pf_telFixoProf: person.pf_telFixoProf || undefined,
          pf_telRamal: person.pf_telRamal || undefined,
          pf_emailPart: person.pf_emailPart || undefined,
          pf_celPart: person.pf_celPart || undefined,
          pf_telFixoPart: person.pf_telFixoPart || undefined,
          pf_nomeContatoEmerg: person.pf_nomeContatoEmerg || undefined,
          pf_telContatoEmerg: person.pf_telContatoEmerg || undefined,
          pf_endLogr: person.pf_endLogr || undefined,
          pf_endNum: person.pf_endNum || undefined,
          pf_endCompl: person.pf_endCompl || undefined,
          pf_cep: person.pf_cep || undefined,
          uf_id: person.uf_id || undefined,
          mun_id: person.mun_id || undefined,
          pf_idiomas: person.pf_idiomas || undefined,
          pf_numCons: person.pf_numCons || undefined,
          pf_ibama: person.pf_ibama || undefined,
        },
      }
      console.tron.log('body handleEditPersonSubmit', body)

      const res = await oikosApi.post('/', body)
      console.tron.log('res handleEditPersonSubmit', res)
      notifySuccess('Perfil atualizado com sucesso.')
      this.setState({ editPersonIsLoading: false })
      this.getPerson()
    } catch (e) {
      notifyError('Não foi possível atualizar as informações do perfil.')
      console.tron.log('Não foi possível atualizar as informações do perfil.', e)
      this.setState({ editPersonIsLoading: false })
    }
  }

  render() {
    const {
      getPersonIsLoading, person, editPersonIsLoading,
      getSexoTypesIsLoading, sexoTypes,
      getEstadoCivilTypesIsLoading, estadoCivilTypes,
      getTipoSanguineoTypesIsLoading, tipoSanguineoTypes,
      getUfTypesIsLoading, ufTypes,
      getMunTypesIsLoading, munTypes,
      getIdiomaTypesIsLoading, idiomaTypes,
    } = this.state

    if (getPersonIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    if (!getPersonIsLoading && person) {
      return (
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Perfil"
              breadcrumbItems={[]}
            />

            <Row>
              <Col>
                <Tabs>
                  <TabList>
                    <Tab>Geral</Tab>
                    <Tab>Contato</Tab>
                    <Tab>Endereço</Tab>
                    <Tab>Profissional</Tab>
                  </TabList>

                  <TabPanel>
                    <Card>
                      <CardBody>
                        <Row xs={1} sm={2} lg={4}>
                          <Col>
                            <FormGroup>
                              <Label>
                                Nome
                              </Label>
                              <Input
                                invalid={person?.pf_nomeInvalid}
                                value={person?.pf_nome}
                                onChange={e => this.setState({
                                  person: {
                                    ...person,
                                    pf_nome: e.target.value,
                                    pf_nomeInvalid: false,
                                  },
                                })}
                              />
                              <FormFeedback>Campo obrigatório.</FormFeedback>
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Sobrenome
                              </Label>
                              <Input
                                invalid={person?.pf_sobrenomeInvalid}
                                value={person?.pf_sobrenome}
                                onChange={e => this.setState({
                                  person: {
                                    ...person,
                                    pf_sobrenome: e.target.value,
                                    pf_sobrenomeInvalid: false,
                                  },
                                })}
                              />
                              <FormFeedback>Campo obrigatório.</FormFeedback>
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Nome de exibição
                              </Label>
                              <Input
                                invalid={person?.pf_nomeExibicaoInvalid}
                                value={person?.pf_nomeExibicao}
                                onChange={e => this.setState({
                                  person: {
                                    ...person,
                                    pf_nomeExibicao: e.target.value,
                                    pf_nomeExibicaoInvalid: false,
                                  },
                                })}
                              />
                              <FormFeedback>Campo obrigatório.</FormFeedback>
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Sexo
                              </Label>
                              <Select
                                isClearable
                                isLoading={getSexoTypesIsLoading}
                                isDisabled={getSexoTypesIsLoading || !sexoTypes}
                                options={sexoTypes}
                                value={sexoTypes?.filter(t => t.value === person?.sexo_id)}
                                onChange={e => this.setState({ person: { ...person, sexo_id: e?.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                RG
                              </Label>
                              <Input
                                value={person?.pf_rg}
                                onChange={e => this.setState({ person: { ...person, pf_rg: e.target.value } })}
                                maxLength={10}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                CPF
                              </Label>
                              <MaskedInput
                                unmask
                                inputRef={el => this.inputCpf = el}
                                mask="000.000.000-00"
                                lazy={false}
                                value={person?.pf_cpf}
                                onAccept={value => this.setState({ person: { ...person, pf_cpf: value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Estado civil
                              </Label>
                              <Select
                                isClearable
                                isLoading={getEstadoCivilTypesIsLoading}
                                isDisabled={getEstadoCivilTypesIsLoading || !estadoCivilTypes}
                                options={estadoCivilTypes}
                                value={estadoCivilTypes?.filter(t => t.value === person?.estCiv_id)}
                                onChange={e => this.setState({ person: { ...person, estCiv_id: e?.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Data de nascimento
                              </Label>
                              <DatePicker
                                placeholderText="__/__/_____"
                                locale="pt-BR"
                                className="form-control"
                                dateFormat="dd/MM/yyyy"
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                maxDate={new Date()}
                                selected={person?.pf_dtNasc ? moment(person.pf_dtNasc).toDate() : null}
                                onChange={date => this.setState({ person: { ...person, pf_dtNasc: date } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Tipo sanguíneo
                              </Label>
                              <Select
                                isClearable
                                isLoading={getTipoSanguineoTypesIsLoading}
                                isDisabled={getTipoSanguineoTypesIsLoading || !tipoSanguineoTypes}
                                options={tipoSanguineoTypes}
                                value={tipoSanguineoTypes?.filter(t => t.value === person?.tpSangue_id)}
                                onChange={e => this.setState({ person: { ...person, tpSangue_id: e?.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Tipo da CNH
                              </Label>
                              <Input
                                value={person?.pf_tpCnh}
                                onChange={e => this.setState({ person: { ...person, pf_tpCnh: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Arrais
                              </Label>
                              <Select
                                isClearable
                                options={YES_OR_NOT}
                                value={YES_OR_NOT.filter(t => t.value === (person?.pf_arrais ? person.pf_arrais : null))}
                                onChange={e => this.setState({ person: { ...person, pf_arrais: e?.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Plano de saúde
                              </Label>
                              <Input
                                value={person?.pf_segSaude}
                                onChange={e => this.setState({ person: { ...person, pf_segSaude: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                CTPS
                              </Label>
                              <Input
                                value={person?.pf_ctps}
                                onChange={e => this.setState({ person: { ...person, pf_ctps: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </TabPanel>

                  <TabPanel>
                    <Card>
                      <CardBody>
                        <Row xs={1} sm={2} lg={4}>
                          <Col>
                            <FormGroup>
                              <Label>
                                Email profissional
                              </Label>
                              <Input
                                value={person?.pf_emailProf}
                                onChange={e => this.setState({ person: { ...person, pf_emailProf: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Celular profissional
                              </Label>
                              <MaskedInput
                                unmask
                                inputRef={el => this.inputCelProf = el}
                                mask="(00) 00000-0000"
                                lazy={false}
                                value={person?.pf_celProf}
                                onAccept={value => this.setState({ person: { ...person, pf_celProf: value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Telefone fixo profissional
                              </Label>
                              <MaskedInput
                                unmask
                                inputRef={el => this.inputTelProf = el}
                                mask="(00) 0000-0000"
                                lazy={false}
                                value={person?.pf_telFixoProf}
                                onAccept={value => this.setState({ person: { ...person, pf_telFixoProf: value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Ramal
                              </Label>
                              <Input
                                type="number"
                                value={person?.pf_telRamal}
                                onChange={e => this.setState({ person: { ...person, pf_telRamal: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Email particular
                              </Label>
                              <Input
                                value={person?.pf_emailPart}
                                onChange={e => this.setState({ person: { ...person, pf_emailPart: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Celular particular
                              </Label>
                              <MaskedInput
                                unmask
                                inputRef={el => this.inputCelPart = el}
                                mask="(00) 00000-0000"
                                lazy={false}
                                value={person?.pf_celPart}
                                onAccept={value => this.setState({ person: { ...person, pf_celPart: value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Telefone fixo particular
                              </Label>
                              <MaskedInput
                                unmask
                                inputRef={el => this.inputTelPart = el}
                                mask="(00) 0000-0000"
                                lazy={false}
                                value={person?.pf_telFixoPart}
                                onAccept={value => this.setState({ person: { ...person, pf_telFixoPart: value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Contato de emergência (Nome)
                              </Label>
                              <Input
                                value={person?.pf_nomeContatoEmerg}
                                onChange={e => this.setState({ person: { ...person, pf_nomeContatoEmerg: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Contato de emergência (Telefone)
                              </Label>
                              <Input
                                value={person?.pf_telContatoEmerg}
                                onChange={e => this.setState({ person: { ...person, pf_telContatoEmerg: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </TabPanel>

                  <TabPanel>
                    <Card>
                      <CardBody>
                        <Row xs={1} sm={2} lg={4}>
                          <Col>
                            <FormGroup>
                              <Label>
                                Logradouro
                              </Label>
                              <Input
                                value={person?.pf_endLogr}
                                onChange={e => this.setState({ person: { ...person, pf_endLogr: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Número
                              </Label>
                              <Input
                                type="number"
                                value={person?.pf_endNum}
                                onChange={e => this.setState({ person: { ...person, pf_endNum: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Complemento
                              </Label>
                              <Input
                                value={person?.pf_endCompl}
                                onChange={e => this.setState({ person: { ...person, pf_endCompl: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                CEP
                              </Label>
                              <MaskedInput
                                unmask
                                inputRef={el => this.inputCep = el}
                                mask="00000-000"
                                lazy={false}
                                value={person?.pf_cep}
                                onAccept={value => this.setState({ person: { ...person, pf_cep: value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                UF
                              </Label>
                              <Select
                                isSearchable
                                isClearable
                                isLoading={getUfTypesIsLoading}
                                isDisabled={getUfTypesIsLoading || !ufTypes}
                                options={ufTypes}
                                value={ufTypes?.filter(t => t.value === person?.uf_id)}
                                onChange={e => this.setState({ person: { ...person, uf_id: e?.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Município
                              </Label>
                              <Select
                                isSearchable
                                isClearable
                                isLoading={getMunTypesIsLoading}
                                isDisabled={getMunTypesIsLoading || !munTypes}
                                options={munTypes}
                                value={munTypes?.filter(t => t.value === person?.mun_id)}
                                onChange={e => this.setState({ person: { ...person, mun_id: e?.value } })}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </TabPanel>

                  <TabPanel>
                    <Card>
                      <CardBody>
                        <Row xs={1} sm={2} lg={4}>
                          <Col>
                            <FormGroup>
                              <Label>
                                Idiomas
                              </Label>
                              <Select
                                isClearable
                                isSearchable
                                isMulti
                                isLoading={getIdiomaTypesIsLoading}
                                isDisabled={getIdiomaTypesIsLoading || !idiomaTypes}
                                options={idiomaTypes}
                                value={idiomaTypes?.filter(item => person?.pf_idiomas?.includes(item.value))}
                                onChange={e => this.setState({ person: { ...person, pf_idiomas: e?.map(f => f.value) } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                Conselho Profissional (nº registro)
                              </Label>
                              <Input
                                value={person?.pf_numCons}
                                onChange={e => this.setState({ person: { ...person, pf_numCons: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup>
                              <Label>
                                CTF IBAMA (nº registro)
                              </Label>
                              <Input
                                value={person?.pf_ibama}
                                onChange={e => this.setState({ person: { ...person, pf_ibama: e.target.value } })}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </TabPanel>
                </Tabs>
              </Col>
            </Row>

            <Row>
              <Col>
                <hr className="mt-2 mb-4" />
              </Col>
            </Row>

            <Row>
              <Col className="d-flex justify-content-end">
                <Button
                  type="button"
                  color="primary"
                  className="ml-3"
                  disabled={editPersonIsLoading}
                  onClick={() => this.handleEditPersonSubmit()}
                >
                  Salvar
                  {editPersonIsLoading && (
                    <Spinner size="sm" className="ml-2" />
                  )}
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ auth: state.auth })
export default connect(mapStateToProps)(Profile)

const YES_OR_NOT = [
  {
    label: 'Não',
    value: '0',
  },
  {
    label: 'Sim',
    value: '1',
  },
]
